import { ThankYouIcon } from "./ThankYouIcon";
import { Callout, Typography } from 'seagull';
import styles from "./RelationshipSigned.module.scss";
import { SuccessPage } from "../../components/SuccessPage";
import React from 'react';
const RelationshipApproved = () => {
  return /*#__PURE__*/React.createElement(SuccessPage, {
    "data-testid": 'relationship-approved-page',
    image: /*#__PURE__*/React.createElement(ThankYouIcon, null)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h3",
    weight: "bold",
    className: styles.header
  }, "Thanks for signing!"), /*#__PURE__*/React.createElement(Callout, {
    intent: "info",
    className: styles.callout,
    hideIcon: true
  }, "You will receive a confirmation email shortly."));
};
export default RelationshipApproved;